export const ADMIN_WELCOME_EMAIL_PATH = '/settings/welcome-email/'
export const SUPER_ADMIN_WELCOME_EMAIL_PATH = id => `/organizations/${id}/welcome-email`
